var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":_vm.title,"width":640,"visible":_vm.visible,"okText":"确认","cancelText":"取消"},on:{"ok":function () {
      _vm.$emit('ok');
    },"cancel":function () {
      _vm.$emit('cancel');
    }}},[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('a-form',_vm._b({attrs:{"form":_vm.form}},'a-form',_vm.formLayout,false),[_c('a-form-item',{attrs:{"label":"资源库名称"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'name',
            { rules: [{ required: true, message: '请输入名称' }] } ]),expression:"[\n            'name',\n            { rules: [{ required: true, message: '请输入名称' }] },\n          ]"}]})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }